<template>
    <div id="contenedor-main-contrato-fechas">
        <v-card
            flat>
            <v-card-text>
                <!-- Loader -->
                <v-skeleton-loader
                    v-if="$apollo.loading"
                    type="table-heading, table-thead, table-tbody"
                ></v-skeleton-loader>
                <!-- Toolbar -->
                <tool-bar
                  v-if="!$apollo.loading"
                  v-on:nuevaFecha="registrarNuevaFecha">
                </tool-bar>
                <v-row>
                  <v-col cols="6">
                    <cronograma
                      :id-contrato="$route.params.idContrato">
                    </cronograma>
                  </v-col>
                  <v-col>
                    <listado
                        v-if="!$apollo.loading"
                        :listado="contratoFechas">
                    </listado>
                  </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog
          v-model="mostrarRegistrarNuevaFecha"
          width="550">
          <agregar-contrato-fecha
              :id-contrato="$route.params.idContrato"
              :tipos-agregados="getTiposAgregados"
              v-on:cerrar="cerrarVentana">
          </agregar-contrato-fecha>
        </v-dialog>
        <v-dialog
          v-model="mostrarActualizarContratoFecha"
          width="550">
          <actualizar-contrato-fecha
            v-if="estaFecha"
            :id-contrato="$route.params.idContrato"
            :fechaEditar="estaFecha"
            :tipos-agregados="getTiposAgregados"
            v-on:cerrar="cerrarVentana">
          </actualizar-contrato-fecha>
        </v-dialog>
        <v-dialog
          v-model="mostrarEliminarContratoFecha"
          width="450">
          <eliminar-contrato-fecha
            v-if="estaFecha"
            :id="estaFecha.id"
            :id-contrato="$route.params.idContrato"
            :texto-eliminar="`${listadoDeTipos[estaFecha.tipo]} ${estaFecha.fecha}`"
            v-on:cerrar="cerrarVentana">
          </eliminar-contrato-fecha>
        </v-dialog>
    </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CONTRATO_FECHAS from '@/graphql/querys/administracion/contratos/fechas/contratoFechas.gql';
import AgregarContratoFecha from '@/components/administracion/contratos/contrato/fechas/Nueva.vue';
import ActualizarContratoFecha from '@/components/administracion/contratos/contrato/fechas/Editar.vue';
import EliminarContratoFecha from '@/components/administracion/contratos/contrato/fechas/Eliminar.vue';
import Cronograma from '@/components/administracion/contratos/contrato/fechas/Cronograma.vue';
import mixContratoFechas from '@/components/administracion/contratos/contrato/fechas/mixContratoFechas';
import ToolBar from './ToolBar.vue';
import listado from './listado/Main.vue';

export default {
  name: 'MainFechasContrato',
  mixins: [mixContratoFechas],
  components: {
    AgregarContratoFecha,
    ActualizarContratoFecha,
    EliminarContratoFecha,
    Cronograma,
    ToolBar,
    listado,
  },
  data() {
    return {
      mostrarRegistrarNuevaFecha: false,
      mostrarActualizarContratoFecha: false,
      mostrarEliminarContratoFecha: false,
      estaFecha: null,
    };
  },
  mounted() {
    eventBus.$on('editar-fecha-contrato', (fecha) => {
      this.estaFecha = fecha;
      this.mostrarActualizarContratoFecha = true;
    });
    eventBus.$on('borrar-fecha-contrato', (fecha) => {
      this.estaFecha = fecha;
      this.mostrarEliminarContratoFecha = true;
    });
  },
  apollo: {
    contratoFechas: {
      query: CONTRATO_FECHAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    registrarNuevaFecha() {
      this.mostrarRegistrarNuevaFecha = true;
    },
    cerrarVentana() {
      this.mostrarRegistrarNuevaFecha = false;
      this.mostrarActualizarContratoFecha = false;
      this.mostrarEliminarContratoFecha = false;
      this.estaFecha = null;
    },
  },
  computed: {
    getTiposAgregados() {
      if (!this.contratoFechas) return [];
      return this.contratoFechas.map(({ tipo }) => tipo);
    },
  },
};
</script>

<style lang="scss">

</style>
